import {
    ActionBtn, LoaderDiv, InputContainer, Label2, MessageError, LoaderText
} from './styles';
import { IPresenterProps } from './types';
import Spinner from '../../../components/Spinner';
import COLORS from '../../../utils/Colors';
// import ReactCodeInput from 'react-verification-code-input';

const LoginContainer = (props: IPresenterProps) => {

    return (
        <>
            <div style={{ marginBottom: 20 }}>
                <InputContainer>
                    <div style={{ marginBottom: 25, width: 450 }}>
                        <Label2 htmlFor="email">Ingresa el código de verificación que acabamos de enviar a tu correo</Label2>
                    </div>
                    {/* <div style={{ marginLeft: 25 }}>
                        <ReactCodeInput
                            values={props.verificationCode}
                            onChange={props.onCodeChange}
                            fields={5}
                            type={'text'}
                            ref={props.verificationCodeRef}
                        />
                    </div> */}
                    {
                        props.messageError &&
                        <MessageError>Código incorrecto, inténtalo de nuevo.</MessageError>
                    }
                </InputContainer>
            </div>

            {props.loaderVisible ? (
                <LoaderDiv>
                    <Spinner size={40} color="#000000" thickness={3} />
                    <LoaderText>Verificando código...</LoaderText>
                </LoaderDiv>
            ) : (
                <>
                    <div style={{ marginLeft: 25 }}>
                        <ActionBtn onClick={props.actionBtn} codeBtnDisabled={props.codeBtnDisabled}>
                            Continuar
                        </ActionBtn>
                    </div>
                    <div onClick={() => props.changeStep(1)} style={{ marginLeft: 25, width: 406, height: 52, marginTop: 28, cursor: 'pointer' }}>
                        <p style={{ textAlign: 'center', fontSize: 18, color: COLORS.white }}>Cancelar</p>
                    </div>
                </>
            )}
        </>
    )
};

export default LoginContainer;
